import React from 'react';

import {useStore} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as CrossIcon} from '../../../../../assets/svg/cross.svg';
import {I18N_NS} from '../../../../../core/constants/names';
import {$allowedActionsForInvoice} from '../../../../../models/common';
import {removeTaxesAndTotalAllowanceCharge} from '../../../../../models/create';
import {$taxesAndTotalAllowanceCharge} from '../../../../../models/create/init';
import {TaxesAndTotalAllowanceCharge} from '../../../../../types/invoices';
import {Icon} from '../../../../ui-kit/Icon';

import {BodyElement, GroupName} from './styled';

export const TaxesTable = () => {
    const taxesAndTotalAllowanceCharge = useStore($taxesAndTotalAllowanceCharge);
    const allowedActionsForInvoice = useStore($allowedActionsForInvoice);
    const {t: translation} = useTranslation(I18N_NS);
    const GEN_INFO = 'pages.documents.invoices.create.taxesTotal.upd';
    const t = (key: string) => translation(`${GEN_INFO}.${key}`);
    function renderTableItem(i: TaxesAndTotalAllowanceCharge, className: string, index: number) {
        let mutualIndex: number;
        return (
            <React.Fragment key={`${index}_${className}`}>
                {Object.entries(i).map(([key, value]) => {
                    if (key === 'mutualIndex') {
                        mutualIndex = value as number;
                        return <React.Fragment key={`${key}`} />;
                    }
                    return (
                        <BodyElement key={`${key}`} className={className}>
                            {typeof value === 'object' && value !== null
                                ? value.label
                                : value || '—'}
                        </BodyElement>
                    );
                })}
                {!allowedActionsForInvoice.edit ? (
                    <div />
                ) : (
                    <div style={{cursor: 'pointer', margin: 'auto'}}>
                        <Icon
                            source={CrossIcon}
                            width={16}
                            height={16}
                            fillColor="#FF4B55"
                            onClick={() => {
                                removeTaxesAndTotalAllowanceCharge(mutualIndex);
                            }}
                        />
                    </div>
                )}
            </React.Fragment>
        );
    }

    return (
        <>
            {!!taxesAndTotalAllowanceCharge.allowances.length && (
                <GroupName style={{gridColumn: '1/-1'}}>{t('allowance')}</GroupName>
            )}
            {taxesAndTotalAllowanceCharge.allowances.map((i, index) =>
                renderTableItem(i, 'allowances', index),
            )}
            {!!taxesAndTotalAllowanceCharge.charges.length && (
                <GroupName style={{gridColumn: '1/-1'}}>{t('charges')}</GroupName>
            )}
            {taxesAndTotalAllowanceCharge.charges.map((i, index) =>
                renderTableItem(i, 'charges', index),
            )}
        </>
    );
};
